<template>
  <div class="t-lk-modal__content t-lk-refuse-lead__container t-lk-attach-contact">
    <h2 class="t-lk-modal__title">{{ $root.staticText.lk.leadsContact }}</h2>

    <div class="t-lk-refuse-lead t-lk-modal__form">
      <div class="t-form__label t-lk-refuse-lead__label">
        {{ select.title }}
        <span v-if="select.requiredField">*</span>
      </div>
      <select-custom-cmp :data="select" ref="selectReason"> </select-custom-cmp>
    </div>
    <transition name="fade">
      <p v-if="!contacts" class="t-lk-attach-contact__add">
        {{ $root.staticText.lk.leadsAddContact }}
      </p>
    </transition>

    <div class="t-lk-attach-contact__btn">
      <transition name="fade">
        <div v-if="!contacts" class="t-btn _green _lk _add" @click="addContact">
          {{ $root.staticText.lk.leadsAddContactBtn }}
        </div>
      </transition>

      <div class="t-btn _green _lk" :class="{ _disabled: disabledBtn }" @click="submit">
        {{ $root.staticText.lk.leadsContactBtn }}
      </div>
    </div>
  </div>
</template>

<script>
import selectCustom from '@components/ui-components/select-custom/select-custom-dynamic-input.vue'
import { mapActions, mapMutations } from 'vuex'
import Vue from 'vue'

export default {
  name: 'attach-contact',
  props: ['props'],
  data() {
    return {
      action: 'lk/leads/addContact',
      disabledBtn: false,
      contacts: true,
      value: '',
      select: {
        title: this.$root.staticText.lk.leadsSelect,
        error: false,
        valid: false,
        hintField: this.$root.staticText.forms.placeholderTypeRequest2,
        value: [],
        requiredField: true,
        list: this.props.optionsContacts,
      },
    }
  },
  components: {
    'select-custom-cmp': selectCustom,
  },
  methods: {
    ...mapActions('modal', ['modalType_lkSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),
    ...mapActions('lk', {
      addLeadContact: 'leads/addContact',
    }),
    ...mapMutations('lk', ['deleteLead', 'setLeads', 'setLeadsCompleted']),

    async submit() {
      if (this.select.value.length === 0) return

      this.disabledBtn = true

      const { success } = await this.addLeadContact({
        id: this.props.leadId,
        contactId: this.select.value[0].id,
      })

      this.disabledBtn = false

      if (!success) return

      this.props.attachHandler?.()
    },
    addContact() {
      this.$router.push({ name: 'lk-staff' })
    },
    searchFilter() {
      this.select.list = []
      this.props.optionsContacts.forEach(item => {
        if (this.value.length) {
          const label = item.label.toLowerCase()
          const email = item.email.toLowerCase()
          const value = this.value.toLowerCase()
          if (label && label.indexOf(value) > -1 && this.select.list.indexOf(item.id) === -1) {
            this.select.list.push(item)
            this.contacts = true
            return
          } else if (email && email.indexOf(value) > -1 && this.select.list.indexOf(item.id) === -1) {
            this.select.list.push(item)
            this.contacts = true
            return
          }
        } else {
          this.select.list = this.props.optionsContacts
        }
      })
      if (!this.select.list.length) {
        this.contacts = false
      }
    },
    openError(data) {
      let text = this.$root.staticText.lk.lkErrorText
      if (data.errors && data.errors.length > 0) {
        let key = Object.keys(data.errors)[0]
        if (data.errors[key][0]) {
          text = data.errors[key][0]
        }
      }
      this.modalType_lkErrorOpen({
        title: this.$root.staticText.lk.lkErrorTitle,
        text: text,
        closeBthNone: true,
      })
    },
  },
  mounted() {
    this.$refs.selectReason.$el.querySelector('input').addEventListener('input', () => {
      this.$refs.selectReason.changeInput()
    })
    this.$refs.selectReason.$el.querySelector('input').addEventListener('focus', () => {
      this.$refs.selectReason.visibleList = true
    })
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/attach-contact.vue